import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { AgencyRawDataPagination } from "../../../../Schema/agencyRawData.types";

export type AgencyRawDataListLoadAction = {
  type: string;
  payload: { id: number | string; page?: number };
};

export type AgencyRawDataListData = {
  data: AgencyRawDataPagination;
  message?: string;
};

const AgencyRawDataList = new ReduxFetchState<
  AgencyRawDataListData | null,
  { id: number | string; page?: number },
  any
>("agencyRawDataList");

export function* watchAgencyRawDataList(action: AgencyRawDataListLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { id, page = 1 } = action.payload;

    const data: { data: AgencyRawDataListData } = yield axios({
      url: `api/v1/ai/agency/${id}/raw-data/list?page=${page}`,
      method: "GET",
      headers: { lang },
    });

    yield put(AgencyRawDataList.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? e?.response?.data?.message ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(AgencyRawDataList.actions.loadFailure(e.message));
  }
}

export function* agencyRawDataListSagas() {
  yield takeEvery(AgencyRawDataList.actionTypes.load, watchAgencyRawDataList);
}

export function useAgencyRawDataList() {
  const { loading, data, ...agencyRawDataListState } = useAppSelector(
    (state) => state.agencyRawDataList,
  );
  const dispatch = useAppDispatch();

  const dispatchAgencyRawDataList = useCallback(
    (payload: { id: number | string; page?: number }) => {
      dispatch(AgencyRawDataList.actions.load(payload));
    },
    [dispatch],
  );

  return {
    ...agencyRawDataListState,
    dispatchAgencyRawDataList,
    agencyRawDataListLoading: loading,
    agencyRawDataListData: data,
  };
}

export const {
  actionTypes: agencyRawDataListActionsTypes,
  actions: agencyRawDataListActions,
  reducer: agencyRawDataListReducer,
} = AgencyRawDataList;